/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Move_ItemsInputs */

const cs_pipelines_move_items = /** @type {(inputs: Pipelines_Move_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přesunout všechny položky`)
};

const en_pipelines_move_items = /** @type {(inputs: Pipelines_Move_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move all items`)
};

/**
* | output |
* | --- |
* | "Move all items" |
*
* @param {Pipelines_Move_ItemsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_move_items = /** @type {((inputs?: Pipelines_Move_ItemsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Move_ItemsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_move_items(inputs)
	return cs_pipelines_move_items(inputs)
});